<template>
        <div>
            <b-breadcrumb>
                <b-breadcrumb-item :to="{ name: 'Home' }">Inicio</b-breadcrumb-item>
                <b-breadcrumb-item :to="{ name: 'User' }">Usuarios</b-breadcrumb-item>
                <b-breadcrumb-item v-if="$route.name !== 'User'">{{ $route.meta.title }}</b-breadcrumb-item>
            </b-breadcrumb>
            <router-view></router-view>
        </div>
</template>
<script>
    export default {
        name: "Layout",
        data() {
            return {

            }
        }
    }
</script>

<style scoped>

</style>